module.exports = __webpack_public_path__ + "static/media/arrow-outline-right.ee97eef0.svg";